import api from './api';

class WorkflowConfigService {
  // Workflow Definitions
  async getWorkflowDefinitions() {
    const response = await api.get('/workflow-engine/definitions/');
    return response.data?.results || response.data || [];
  }

  async getWorkflowDefinition(id) {
    const response = await api.get(`/workflow-engine/definitions/${id}/`);
    return response.data;
  }

  async createWorkflowDefinition(data) {
    const response = await api.post('/workflow-engine/definitions/', data);
    return response.data;
  }

  async updateWorkflowDefinition(id, data) {
    const response = await api.put(`/workflow-engine/definitions/${id}/`, data);
    return response.data;
  }

  async deleteWorkflowDefinition(id) {
    await api.delete(`/workflow-engine/definitions/${id}/`);
  }

  // Workflow Steps
  async getWorkflowSteps(workflowId) {
    const response = await api.get(`/workflow-engine/definitions/${workflowId}/`);
    return response.data.steps || [];
  }

  async createWorkflowStep(data) {
    const response = await api.post('/workflow-engine/steps/', data);
    return response.data;
  }

  async updateWorkflowStep(id, data) {
    const response = await api.put(`/workflow-engine/steps/${id}/`, data);
    return response.data;
  }

  async deleteWorkflowStep(id) {
    await api.delete(`/workflow-engine/steps/${id}/`);
  }

  async reorderSteps(workflowId, stepOrders) {
    // stepOrders: [{ id: 1, order: 1 }, { id: 2, order: 2 }, ...]
    const response = await api.post(`/workflow-engine/definitions/${workflowId}/reorder-steps/`, {
      step_orders: stepOrders
    });
    return response.data;
  }

  // Clone workflow
  async cloneWorkflow(id, newName) {
    const response = await api.post(`/workflow-engine/definitions/${id}/clone/`, {
      name: newName
    });
    return response.data;
  }
}

export default new WorkflowConfigService();
